import * as $ from 'jquery';
import * as MobileDetect from 'mobile-detect';
require('popper.js');
require('bootstrap');

$(document).ready(function(){
    const md = new MobileDetect(window.navigator.userAgent);
    const os = md.os();

    if (os == "iOS" || os == "AndroidOS" || os == "iPadOS") {
        $('.btn-vipps').click( () => {
            window.location.href = "https://qr.vipps.no/28/2/05/031/DVGNRgT0M";
        });
    } else {
        
        $('.btn-vipps').popover({
            content: '<img src="/img/vipps-qr.png" class="vipps-qr">',
            html: true,
            placement: 'top',
            trigger: 'click',
            offset: 0
        });

        $('body').on('click', function (e) {
            $('.btn-vipps').each(function () {
                //the 'is' for buttons that trigger popups
                //the 'has' for icons within a button that triggers a popup
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0) {
                    $(this).popover('hide');
                }
            });
        });
    }
});
